import { OfferInfo } from "~/app/core/model/offer-info";
import { toDateStr } from "~/app/core/model/date-str";

export const SAMPLE_ADS = [
    {
        name: "Your time in the sky",
        adImageUrl: "https://pro2-bar-s3-cdn-cf6.myportfolio.com/e4f231b9d3fce9a50c052f49b34aa534/7e4e5a72-0d01-48ba-ae70-9b8bb770fd65_rw_1200.jpg?h=80801063398a2b544cbb32185d8fffa0",
        destinationUrl: "https://www.delta.com"
    },
    {
        name: "ad",
        adImageUrl: "https://fliphound.com/creative-example-image/d169ca30-74bd-4b84-83eb-ffe1c3cc7b87/fliphound-automotive-car-dealer-luxury-branding-billboard-ad",
        destinationUrl: "http://whutsfree.com"
    },
    {
        name: "ad",
        adImageUrl: "https://www.wiggywash.com/wp-content/uploads/2018/08/VeteranOwned_Slider1.png",
        destinationUrl: "https://www.wiggywash.com/product/leather-treatment/"
    }
];

export const SAMPLE_SPONSORS = [
    {
        id: 0,
        name: "Delta Airlines",
        logoImageUrl: "https://cdn-news.warriortrading.com/wp-content/uploads/2018/07/19180826/Emblem-Delta-Air-Lines.jpg",
        destinationUrl: "https://www.delta.com",
        videoUrl: "https://d3npuic909260z.cloudfront.net/001/762/074/dL4p.mp4",
        ad: SAMPLE_ADS[0]
    },
    {
        id: 1,
        name: "sponsor",
        logoImageUrl: "https://image.shutterstock.com/image-vector/concept-auto-vehicle-dealership-logo-450w-597341939.jpg",
        destinationUrl: "https://test.com",
        videoUrl: "https://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4",
        ad: SAMPLE_ADS[1]
    },
    {
        id: 2,
        name: "Wiggy Wash",
        logoImageUrl: "https://wifast-hashed.s3.amazonaws.com/production/hash-9cf1673eed8461a0916e290af2340720",
        destinationUrl: "https://www.wiggywash.com/product/leather-treatment/",
        videoUrl: "https://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4",
        ad: SAMPLE_ADS[2]
    }
];

export const SAMPLE_OFFERS: Array<OfferInfo> = [
    {
        id: 0,
        free: true,
        bounceback: false,
        revealCost: 1,
        revealed: false,
        favoriteCost: 1,
        favorite: false,
        repeatUnlockCost: 1,
        repeatUnlocked: false,
        sample: false,
        name: "Free Hamburger!",
        terms: "One free jumbo-burger with any toppings you want. No purchase necessary.",
        expirationDate: toDateStr(new Date("2019-02-28T00:00:00")),
        imageUrl: "https://www.101cookingfortwo.com/wp-content/uploads/2017/07/How-to-Grill-an-Excellent-Burger-1-2.jpg",
        companyId: 1,
        companyName: "The Burger Barn",
        companyLogoUrl: "http://troop483.weebly.com/uploads/2/6/5/0/26508655/9543671_orig.png",
        companyWebUrl: null,
        reviewUrl: null,
        addresses: [{
            street1: "4951 FM 1283",
            city: "Pipe Creek",
            state: "TX",
            zip: "78063",
            phone: "(801) 555-5432",
            longitude: -134.323,
            latitude: 65.4345
        }],
        bounceBackOfferId: null
    },
    {
        id: 1,
        free: true,
        bounceback: false,
        revealCost: 1,
        revealed: false,
        favoriteCost: 1,
        favorite: false,
        repeatUnlockCost: 1,
        repeatUnlocked: false,
        sample: false,
        name: "Free Titleist Ball!",
        terms: "Titleist golf balls are relied on by the game's finest players. Get yours today.",
        expirationDate: toDateStr(new Date("2019-04-23T00:00:00")),
        imageUrl: "https://www.titleist.com/teamtitleist/cfs-file/__key/communityserver-blogs-components-weblogfiles/00-00-00-00-19/1460.ProV1x_5F00_1460x821-2017.jpg",
        companyId: 2,
        companyName: "The Golf Warehouse",
        companyLogoUrl: "https://www.tgw.com/wcsstore/StorefrontAssetStore/images/responsive/mobile-logo.png",
        companyWebUrl: "https://www.tgw.com",
        reviewUrl: "https://www.yelp.com/biz/the-golf-warehouse-wichita-3",
        addresses: [{
            street1: "8851 E 34th St N",
            city: "Wichita",
            state: "KS",
            zip: "67226",
            phone: "(316) 858-0462",
            longitude: -97.233979,
            latitude: 37.745576
        }],
        redeemedDate: toDateStr(new Date("2019-04-23T00:00:00")),
        bouncebackDate: toDateStr(new Date("2019-04-24T00:00:00")),
        bounceBackOfferId: 5
    },
    {
        id: 5,
        free: false,
        bounceback: true,
        revealCost: 1,
        revealed: true,
        favoriteCost: 1,
        favorite: true,
        repeatUnlockCost: 1,
        repeatUnlocked: false,
        sample: false,
        name: "50% Off Datang Dragon Clubs!",
        terms: "2018 New golf irons datang dragon skull forged set with original dynamic gold S300 steel shaft golf clubs.",
        expirationDate: toDateStr(new Date("2019-04-23T00:00:00")),
        imageUrl: "https://ae01.alicdn.com/kf/HTB1UY7sfC_I8KJjy0Foq6yFnVXa6/2018-New-golf-irons-datang-dragon-skull-forged-set-3-4-5-6-7-8-9.jpg_640x640.jpg",
        companyId: 2,
        companyName: "The Golf Warehouse",
        companyLogoUrl: "https://www.tgw.com/wcsstore/StorefrontAssetStore/images/responsive/mobile-logo.png",
        companyWebUrl: "https://www.tgw.com",
        reviewUrl: "https://www.yelp.com/biz/the-golf-warehouse-wichita-3",
        addresses: [{
            street1: "8851 E 34th St N",
            city: "Wichita",
            state: "KS",
            zip: "67226",
            phone: "(316) 858-0462",
            longitude: -97.233979,
            latitude: 37.745576
        }],
        bounceBackOfferId: null
    },
    {
        id: 2,
        free: true,
        bounceback: false,
        revealCost: 1,
        revealed: false,
        favoriteCost: 1,
        favorite: false,
        repeatUnlockCost: 1,
        repeatUnlocked: false,
        sample: false,
        name: "Free Champion's League Ball!",
        terms: "Official matchball of the UEFA Champions League.",
        expirationDate: toDateStr(new Date("2020-01-01T00:00:00")),
        imageUrl: "https://www.uefa.com/MultimediaFiles/Photo/uefaorg/Marketing/02/58/98/24/2589824_w1.jpg",
        companyId: 3,
        companyName: "UEFA",
        companyLogoUrl: "https://img.uefa.com/imgml/uefacom/elements/social/og-default.jpg",
        companyWebUrl: "https://www.uefa.com/insideuefa/about-uefa/",
        reviewUrl: null,
        addresses: [{
            street1: "Route de Genève 46",
            city: "Nyon",
            state: "Switzerland",
            zip: "CH-1260",
            phone: "+41 (0) 848 04 2727 ",
            longitude: -97.233979,
            latitude: 37.745576
        }],
        bounceBackOfferId: null
    },
    // {
    //     id: 3,
    //     name: "Free Lamborghini Photograph!",
    //     terms: "A picture of a Lamborghini Aventador Coupe. Car not included.",
    //     expirationDate: new Date("2020-01-01T00:00:00"),
    //     imageUrl: "https://www.lamborghini.com/sites/it-en/files/DAM/lamborghini/share%20img/aventador-coupe-facebook-og.jpg",
    //     companyName: "Auto Zone",
    //     companyLogoUrl: "https://halpernent.com/wp-content/uploads/2018/02/AutoZone-Logo-300x158.png",
    //     companyWebUrl: "https://www.autozone.com/",
    //     addressStreet: "1220 EAST STATE STREET",
    //     addressCity: "LEHI",
    //     addressState: "UT",
    //     addressZip: "84043",
    //     companyPhone: "(385) 345-9705",
    //     longitude: -97.233979,
    //     latitude: 37.745576,
    //     sponsor: SAMPLE_SPONSORS[2]
    // },
    {
        id: 4,
        free: true,
        bounceback: false,
        revealCost: 1,
        revealed: false,
        favoriteCost: 1,
        favorite: false,
        repeatUnlockCost: 1,
        repeatUnlocked: false,
        sample: false,
        name: "Free Pop Rocks!",
        terms: "One free pack of Pop Rocks X-treme. Any available flavors.",
        expirationDate: toDateStr(new Date("2020-01-01T00:00:00")),
        imageUrl: "https://images.vat19.com/extreme-pop-rocks/sour-extreme-pop-rocks-flavors.jpg",
        companyId: 4,
        companyName: "Candy Shop",
        companyLogoUrl: "https://banner2.kisspng.com/20180328/hae/kisspng-candy-shop-logo-confectionery-store-twix-candy-5abb9840be95e1.9010174615222436487807.jpg",
        companyWebUrl: "",
        reviewUrl: null,
        addresses: [{
            street1: "1220 EAST STATE STREET",
            city: "LEHI",
            state: "UT",
            zip: "84043",
            phone: "(385) 345-9705",
            longitude: -97.233979,
            latitude: 37.745576
        }],
        bounceBackOfferId: null
    }
];
